var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDualArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 31,
    viewBox: "0 0 28 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3055 8.70711C27.6961 8.31658 27.6961 7.68342 27.3055 7.29289L20.9416 0.928932C20.5511 0.538408 19.9179 0.538408 19.5274 0.928932C19.1368 1.31946 19.1368 1.95262 19.5274 2.34315L25.1842 8L19.5274 13.6569C19.1368 14.0474 19.1368 14.6805 19.5274 15.0711C19.9179 15.4616 20.5511 15.4616 20.9416 15.0711L27.3055 8.70711ZM1.39844 9H26.5984V7H1.39844V9Z",
    fill: "#0F4C86"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.692501 22.6933C0.301977 23.0838 0.301977 23.717 0.692501 24.1075L7.05646 30.4715C7.44699 30.862 8.08015 30.862 8.47068 30.4715C8.8612 30.0809 8.8612 29.4478 8.47068 29.0572L2.81382 23.4004L8.47068 17.7435C8.8612 17.353 8.8612 16.7198 8.47068 16.3293C8.08015 15.9388 7.44699 15.9388 7.05646 16.3293L0.692501 22.6933ZM26.5996 22.4004L1.39961 22.4004V24.4004L26.5996 24.4004V22.4004Z",
    fill: "#0F4C86"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDualArrow);
export default __webpack_public_path__ + "static/media/dual-arrow.3a98e5bcc6706c2fb2988f39a19a18f6.svg";
export { ForwardRef as ReactComponent };